import React from 'react'
import { Box, Typography, Container } from '@mui/material'
import Navbar from '../../../shared/Navbar'
import LuckyDrawForm from './LuckyDrawForm'

const LuckyDraw = () => (
  <Container component='main'>
    <Navbar />
    <Box textAlign='center' mt={12} mb={8}>
      <Typography
        sx={{
          fontSize: { xs: '30px', md: '50px' },
          fontFamily: 'Corsica LX Bold',
          lineHeight: 1,
        }}
      >
        Lucky Draw
      </Typography>
    </Box>
    <Box m={2} mb={8}>
      <LuckyDrawForm></LuckyDrawForm>
    </Box>
  </Container>
)

export default LuckyDraw
